import React, { useEffect, useState } from "react";
import badgesBg from "../../../../assets/images/others/host-side-images/badgesBg.png";
import { useSelector } from "react-redux";
import useUtils from "hooks/useUtils";
import useAttendee from "containers/attendee/useHooks";
import { BAGDE_TYPES } from "utils/helpers/enums/shared.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import noFoundGif from "assets/images/gifs/noFoundGif.gif";
const DigitalPassport: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [activeTab, setActiveTab] = useState("Learn Local’s Badges");
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const { getQueryParams } = useUtils();
  const params = getQueryParams();

  // Fetching Badges
  const { getMyBadges } = useAttendee();
  useEffect(() => {
    if (activeTab === "Learn Local’s Badges") {
      const payload = {
        badgeType: BAGDE_TYPES.ACHIEVEMENT,
        userId: params?.id,
      };
      getMyBadges(setData, payload);
    } else if (activeTab === "Event Badges") {
      const payload = {
        badgeType: BAGDE_TYPES.EVENT,
        userId: params?.id,
      };
      getMyBadges(setData, payload);
    }
  }, [activeTab]);

  useEffect(() => {
    if (isInitialLoad && !isLoading) {
      setIsInitialLoad(false);
    }
  }, [isLoading, data]);

  return (
    <div className="min-h-[50vh]">
      <h1 className="text-blackie text-3xl font-medium py-4">
        My Digital Passport
      </h1>
      {/* Tab Navigation */}
      <div className="flex justify-start mb-6">
        <button
          type="button"
          className={`px-4 py-2 text-sm font-semibold ${
            activeTab === "Learn Local’s Badges"
              ? "text-lightBlueColor border-b-2 border-lightBlueColor"
              : "text-grayText"
          }`}
          onClick={() => setActiveTab("Learn Local’s Badges")}
        >
          Learn Local’s Badges
        </button>
        <button
          type="button"
          className={`px-4 py-2 text-sm font-semibold ${
            activeTab === "Event Badges"
              ? "text-blue-600 border-b-2 border-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("Event Badges")}
        >
          Event Badges
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "Learn Local’s Badges" && (
          <div>
            <div className="flex flex-wrap gap-4 py-5">
              {data?.map((badge: any) => (
                <div
                  key={badge.id}
                  className="flex flex-col items-center justify-center p-4 rounded-lg w-[235px] h-[260px]"
                  style={{ backgroundImage: `url(${badgesBg})` }}
                >
                  <div className="hover:scale-110 transition-transform duration-300">
                    <img
                      src={concatPathWithBackendUrl(badge?.image?.name)}
                      alt="badge"
                    />
                  </div>
                  <span className="text-sm font-medium mt-2 text-blackie">
                    {badge.name}
                  </span>
                </div>
              ))}
            </div>

            <div>
              <CustomMessageDisplay
                show={!isLoading && !isInitialLoad && !data.length}
                title="No Learn Local Badges Earned"
                slogan="Complete experiences and activities to earn your first Learn Local badge!"
                image={noFoundGif}
                imageAlt="No event badges found"
                className="py-16"
                imageClassName="w-24 h-24"
                titleClassName="text-2xl font-bold text-blackie"
                sloganClassName="text-gray-500 text-base"
              />
            </div>
          </div>
        )}

        {activeTab === "Event Badges" && (
          <>
            <div className="flex flex-wrap gap-4 py-5">
              {data?.map((badge: any) => (
                <div
                  key={badge.id}
                  className="flex flex-col items-center justify-center p-4 rounded-lg w-[235px] h-[260px]"
                  style={{ backgroundImage: `url(${badgesBg})` }}
                >
                  <div className="hover:scale-110 transition-transform duration-300">
                    <img
                      src={concatPathWithBackendUrl(badge?.image?.name)}
                      alt="badge"
                    />
                  </div>
                  <span className="text-sm font-medium mt-2 text-blackie">
                    {badge.name}
                  </span>
                </div>
              ))}
            </div>
            <div>
              <CustomMessageDisplay
                show={!isLoading && !isInitialLoad && !data.length}
                title="No Event Badges Earned"
                slogan="Participate in events to earn your first event badge!"
                image={noFoundGif}
                imageAlt="No event badges found"
                className="py-16"
                imageClassName="w-24 h-24"
                titleClassName="text-2xl font-bold text-blackie"
                sloganClassName="text-gray-500 text-base"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DigitalPassport;
